import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../hooks/store';
import { date2human, time2human } from '../utils/dateTime';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import Overlay from '../components/common/Overlay';
import './Print.css';
import { Slot } from '../types';
import getFileURL from '../utils/getFileURL';

type DateItem = {
    date: string; // YYYY-MM-DD
    ru: string; // 1 Декабря
    en: string; // 1 December
};

const Print = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const company = i18n.language === 'en' ? 'company_en' : 'company_ru';
    const position = i18n.language === 'en' ? 'position_en' : 'position_ru';
    const user = useAppSelector(store => store.auth.user);
    const event = useAppSelector(store => store.event);
    const slots = useAppSelector(store => store.slots);
    const requests = useAppSelector(store => store.requests);
    const attendees = useAppSelector(store => store.attendees);
    const [ dates, setDates ] = useState<DateItem[]>([]);

    // Формируем список дат
    useEffect(() => {
        let date = '';
        let list: DateItem[] = [];
        for(let i = 0; i < slots.length; i ++) {
            const current = slots[i].start.split('T')[0];
            if(date !== current) {
                date = current;
                list.push({
                    date,
                    ru: date2human(slots[i].start, 'ru'),
                    en: date2human(slots[i].start, 'en'),
                });
            }
        }
        if(list.length) {
            setDates(list);
        }
    }, [ slots ]);

    const printSlot = (slot: Slot, date: DateItem) => {
        // Если не ткущий день, скипаем
        if(!slot.start.startsWith(date.date)) return null;
        // Ищем подтвержденные встречи среди заросов
        const req = requests.find(r => r.slot_id === slot.id && r.status === 'approved' && r.to_id !== r.from_id);
        if(req) {
            const aid = req.from_id === user?.id ? req.to_id : req.from_id;
            const respondent = attendees.find(a => a.id === aid);
            if(respondent) return <>
                <div>{time2human(slot.start)}</div>
                <img alt='avatar' src={getFileURL(respondent.avatar)}/>
                <div>
                    <b>{respondent[name]}</b><br/>
                    <small>{respondent[company]}</small><br/>
                    <small>{respondent[position]}</small>
                </div>
            </>;
            else return <>
                <div>{time2human(slot.start)}</div>
                <img alt='avatar' src={getFileURL(null)}/>
                <div>Unknown</div>
            </>;
        }
        // Нет встречи на этот слот
        return null;
    };

    return <Overlay wide>
        <div className='Print'>
            {event && <div className='Event'>
                <img alt='logo' src={getFileURL(event.logo)}/>
                <div>
                    {event[name]}
                    {user
                    ? <div>{user[name]}<br/>{user[company]}</div>
                    : <><br/>{t('profile.schedule')}</>}
                </div>
                <div>
                    <span className='PrintButton' onClick={() => window.print()}>
                        <Icon icon={faPrint}/>&nbsp;&nbsp;
                        <span className='a'>{t('profile.print')}</span>
                    </span>
                </div>
            </div>}

            {dates.map(date => <div key={date.date}>
                <h2>{date[lang]}</h2>
                <p>{t('common.nomeetings')}</p>
                <div className='List'>
                {slots.map(slot => <div className='Slot' key={slot.id}>{printSlot(slot, date)}</div>)}
                </div>
            </div>)}

        </div>
    </Overlay>
};

export default Print;
